<template>
    <v-container>
        <mission-form schema="new" title="NUEVA MISION" />
    </v-container>
</template>

<script>
import missionForm from "../../components/Forms/missionForm.vue";


export default {
    components: {
        missionForm
    },
}
</script>
